import App from '@/App'
import * as services from '@/services/auth'
import { getUserInfo } from '@/services/personalCenter/personalInfo'
import _ from 'lodash'
import { dealToXss } from '@/pages/Survey/AnswerSurvey/util'
const state = {
  language: 'zh',
  count: 1,
  serverToken: '',
  activeMenuIndex: '/personalCenter', //顶部菜单索引
  activeSiderMenuIndex: '/personalCenter/personalInfo', //侧边菜单索引
  tagRoutes: [],
  activeTagRoute: '',
  permissionsControl: {},
  menuDic: {
    角色管理: 'roleManagement',
    账号管理: 'accountManagement',
    账号组管理: 'accountGroupManagement',
    公告管理: 'announcementManagement',
    系统反馈: 'systemFeedback'
  },
  loading: false,
  dynamicInfoList: [], //用户动态事件list
  announcementVisible: false, //公告显示隐藏-弹窗
  announcementqeeVisible: false, //公告显示隐藏-走马灯
  announcementOnlyShow: false, //公告纯展示，预览状态
  announcementData: {} //公告数据
}

const mutations = {
  setTagRoutes: (state, tagRoutes) => {
    state.tagRoutes = tagRoutes
  },
  setActiveTagRoute: (state, activeTagRoute) => {
    state.activeTagRoute = activeTagRoute
  },
  setActiveMenuIndex: (state, activeMenuIndex) => {
    state.activeMenuIndex = activeMenuIndex
  },
  setActiveSiderMenuIndex: (state, activeSiderMenuIndex) => {
    state.activeSiderMenuIndex = activeSiderMenuIndex
  },
  SET_LANGUAGE: (state, language) => {
    state.language = language
  },
  commonMutations: (state, payload) => {
    Object.keys(payload).forEach((item) => {
      state[item] = payload[item]
    })
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  }
}

const actions = {
  handleIconClick(context, payload) {},

  getServerToken({ state, commit }) {
    services.getToken().then((res) => {
      if (res?.code === 200) {
        commit('commonMutations', { serverToken: res?.data?.siamtgt })
      }
    })
  },
  getAccountAuthority({ state, commit }) {
    getUserInfo().then((userInfo) => {
      const { roleName = [], isEventAdmin } = userInfo.data || {}
      sessionStorage.setItem('isEventAdmin', isEventAdmin)
      services.getAccountAuthority().then((res) => {
        if (res?.code === 200) {
          let lsObj = {}
          res?.data?.allMenu
            .filter(
              (item) => item.module === '设置' && item.subModule !== '渠道管理'
            )
            ?.forEach((element) => {
              if (!lsObj[state.menuDic[element.subModule]]) {
                lsObj[state.menuDic[element.subModule]] = {}
              }
              lsObj[state.menuDic[element.subModule]][element.operation] =
                res?.data?.authorityMenu.includes(element.id)
            })
          if (!roleName?.includes('IT角色')) {
            lsObj['announcementManagement'].get = false
          }
          if (
            roleName?.includes('IT角色') &&
            ['testAll', 'zh', 'sin'].includes(window.env.SITE_ENV)
          ) {
            lsObj['userEvent'] = { get: true }
          }
          commit('commonMutations', { permissionsControl: _.cloneDeep(lsObj) })
        }
      })
    })
  },
  getTemplateDynamicInfo({ state, commit }) {
    services.getTemplateDynamicInfo().then((res) => {
      if (res?.code === 200) {
        commit('commonMutations', { dynamicInfoList: _.cloneDeep(res.data) })
      }
    })
  },
  getAnnouncementLastOne({ state, commit }, payload) {
    services.getLastOneAnn(payload).then((res) => {
      if (res?.code === 200) {
        commit('commonMutations', { announcementData: _.cloneDeep(res.data) })
        if (res.data) {
          if (res.data.noticeType === 1) {
            commit('commonMutations', { announcementVisible: true })
            commit('commonMutations', { announcementqeeVisible: false })
          } else {
            commit('commonMutations', { announcementqeeVisible: true })
            commit('commonMutations', { announcementVisible: false })
          }
        }
      }
    })
  }
}
const getters = {
  getCount() {
    return state.count * 2
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
